import React, { Component } from "react";
import UnhappyCustomerPopup from "../components/AddBankDetails/unhappyCustomerPopup";
import { connect } from "react-redux";
import { clearAllLevel } from "../SequenceHandler";
import { closeAlert, redirectToAnotherApplication } from "../actions/crossSellApplicationActions";
import { getHeaderStatus, getTeamData, isMobileChannel } from "../utils/is.after";
import { isMobileNativeApp } from "../utils/mobileAppCheck";
class Navigation extends Component{
    state = {
      title: "",
      backBtnClass: '',
      closeBtnClass: "",
      popupWindow: false,
      backBtnClassMargin: '',
      mobileChannelSourceCloseBtn: ''
    };
    constructor(props){
      super(props);
      const isHeaderShow=isMobileNativeApp()||getHeaderStatus(props.offerPreFilled.channelSource);
      let mobileChannelSourceCloseBtn;
      let info =props.info;
      if(info) {
        this.state.title=info.title;
        this.state.backBtnClass=info.backBtnClose ? "hide" : "";
        this.state.closeBtnClass= info.closeBtnClose ? "hide" : "";
        this.state.backBtnClassMargin=info.backBtnClose ? "m-l-30-back-btn" : "";
        this.state.mobileChannelSourceCloseBtn=isHeaderShow?"header-font standard-blue text-right window-btn header-x-btn":"header-font standard-blue text-right window-btn";
      }
    }

   goBack =()=>{
     let tab = this.props.bankAccountInfo.tabs;
     if(tab && "callBackFun" in tab && typeof tab.callBackFun === "function"){
       tab.callBackFun();
     }else{
       if(this.props.info.level === 1){
         const channel = this.props.offerPreFilled.channelSource;
         if(isMobileChannel(channel)){
           this.props.redirectURL(getTeamData(channel).backURL);
         }else{
           this.props.redirectURL(this.props.offerPreFilled.ssoReferrer, true);
         }
       }else{
         this.props.history.goBack();
       }
     }
     this.props.closeAlert(false);
   };

   componentWillReceiveProps=(nextProps)=>{
     let updatedInfo = nextProps.info;
     if(updatedInfo) {
       this.setState({
         title: updatedInfo.title,
         backBtnClass: updatedInfo.backBtnClose ? "hide" : "",
         closeBtnClass: updatedInfo.closeBtnClose ? "hide" : ""
       });
     }
   };

    togglePopupWindow =(redirect)=>{
      let info = this.props.info;
      if(!info.disablePopUp){
        this.setState({ popupWindow: !this.state.popupWindow });
        if(redirect){
          clearAllLevel();
          this.props.redirectURL(this.props.offerPreFilled.ssoReferrer);
        }
      } else {
        this.props.redirectURL(this.props.offerPreFilled.ssoReferrer);
      }
    };

    render(){
      const popup =(this.state.popupWindow?<UnhappyCustomerPopup togglePopupWindow={this.togglePopupWindow} offerPreFilled={this.props.offerPreFilled}/>:null);
      return (
        <div className="d-flex">
          <div className={`p-2 window-btn-left ${this.state.backBtnClass}`}>
            <h3 className="header-font standard-blue text-left back-page-icon window-btn" onClick={this.goBack} tabIndex="0"
              onKeyDown={e=> {
                let key = e.keyCode;
                if(key === 13||key === 32) {
                  this.goBack();
                }
              }}
            >&nbsp;</h3>
          </div>
          <div className={`p-2 flex-fill ${this.state.backBtnClassMargin}`}>
            <h3 className="header-font standard-blue text-center">{this.state.title}</h3>
          </div>
          <div className={`p-2 window-btn-right ${this.state.closeBtnClass}`}>
            <h3 className={`${this.state.mobileChannelSourceCloseBtn}`} onClick={()=>this.togglePopupWindow(false)} tabIndex="0"
              onKeyDown={e=> {
                let key = e.keyCode;
                if(key === 13||key === 32) {
                  this.togglePopupWindow(false);
                }
              }}>&times;</h3>
          </div>
          {popup}
        </div>

      );
    }
}
const mapStateToProps = (state) => {
  return { bankAccountInfo: state.bankAccountInfo };
};
const mapDispatchToProps={ redirectURL: redirectToAnotherApplication, closeAlert: closeAlert };
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
